function m(e, r) {
  const t = e.textarea, n = t.selectionStart ?? 0, l = t.selectionEnd ?? 0;
  t.setRangeText(r, n, l, "end"), e.updatePreview?.(), t.focus();
}
function f(e = {}) {
  const r = e.label ?? "🖼️", t = e.title ?? "Insert image";
  return (n) => {
    const l = n.container?.querySelector?.(".marzipan-toolbar") ?? n.container, a = document.createElement("button");
    a.type = "button", a.title = t, a.className = "mz-btn mz-btn-image", a.textContent = r, a.onclick = async () => {
      const p = e.promptMessage ?? 'Paste an image URL, or type "upload" to pick a file:', d = e.placeholder ?? "", u = prompt(p, d);
      if (!u) return;
      const i = u.trim();
      if (!i) return;
      if (i.toLowerCase() !== "upload") {
        m(n, `![alt text](${i})`);
        return;
      }
      const c = document.createElement("input");
      c.type = "file", c.accept = "image/*", c.onchange = async () => {
        const o = c.files?.[0];
        if (o)
          try {
            const s = e.uploader ? await e.uploader(o) : URL.createObjectURL(o);
            m(n, `![${o.name}](${s})`);
          } catch (s) {
            console.error("Image upload failed:", s), alert("Image upload failed.");
          }
      }, c.click();
    }, l?.appendChild(a);
  };
}
export {
  f as imagePickerPlugin
};
//# sourceMappingURL=imagePicker.js.map
